export default __webpack_public_path__ + "static/media/ok6.cc3b03dc.svg";